import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const PaymentPreviewPortalElement = styled(Box, {
  label: 'PaymentPreviewPortalElement',
})(() => ({
  height: '100%',
  width: 'fit-content',
  boxShadow: '0px 4px 15px rgba(79, 116, 209, 0.4)',
  position: 'absolute',
  zIndex: 1,
}));

export const PaymentWidgetPanel = styled('div', {
  label: 'PaymentWidgetPanel',
  shouldForwardProp: (propName) => !['hide'].includes(propName as string),
})<{ hide?: boolean }>(({ hide }) => ({
  display: hide ? 'none' : 'block',
  position: 'relative',
  width: 34,
  minWidth: 34,
  flexGrow: 1,
  zIndex: 20,
}));
